import { render } from "./AccG.vue?vue&type=template&id=4ce360c6"
import script from "./AccG.vue?vue&type=script&lang=js"
export * from "./AccG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__